import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
import { CountdownBanner } from './CountdownBanner';
export function FeatureGrid() {
  return <section className="py-6 px-4 bg-[#0d0d0d] relative overflow-hidden" data-id="element-104">
      <div className="max-w-6xl mx-auto" data-id="element-105">
        {/* Product Video */}
        <div className="max-w-3xl mx-auto" data-id="element-106">
          <video autoPlay muted loop playsInline preload="none" style={{
          width: '100%',
          height: 'auto',
          borderRadius: '50px',
          boxShadow: '0 0 20px rgba(255,120,0,0.28)',
          display: 'block',
          overflow: 'hidden'
        }} data-id="element-107">
            <source src="https://cdn.shopify.com/videos/c/o/v/77b6474dbe144098a2ab51a577d471b1.mp4" type="video/mp4" data-id="element-108" />
          </video>
        </div>

        {/* Stats Bar */}
        <div className="mt-10 grid grid-cols-3 gap-4 md:gap-8" data-id="element-109">
          {[{
          num: '600+',
          label: 'Planos Metálicos'
        }, {
          num: '24h',
          label: 'Para Terminar Piezas'
        }, {
          num: '0',
          label: 'Desperdicio de Material'
        }].map((stat, i) => <div key={i} className="text-center p-4 bg-[#1a1a1a] rounded-lg border border-[#333] hover:border-[#FF6B00]/30 transition-colors shadow-lg" data-id="element-110">
              <div className="text-4xl md:text-5xl font-bold text-[#FF6B00] mb-2" style={{
            fontSize: '28px'
          }} data-id="element-111">
                {stat.num}
              </div>
              <div className="text-sm md:text-base text-gray-300 font-medium uppercase tracking-wide" style={{
            fontSize: '12px'
          }} data-id="element-112">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Price, CTA and Countdown */}
        <div className="flex flex-col items-center text-center mt-8" data-id="element-113">
          <div className="mb-4" data-id="element-114">
            <p className="text-gray-400 text-sm mb-2 uppercase tracking-wide" data-id="element-115">
              PRECIO DE OFERTA:
            </p>
            <PriceDisplay amount={16.99} originalAmount={49.99} className="text-4xl md:text-5xl font-black text-white" data-id="element-116" />
          </div>

          <CTAButton size="xl" className="w-full md:w-auto mb-2 text-sm md:text-xl" href="https://carlosponte.com/cart/add?id=56937498575173&quantity=1" data-id="element-117">
            QUIERO MIS PLANOS
          </CTAButton>

          <p className="text-sm text-gray-400 mb-1" data-id="element-118">
            Acceso Inmediato a +600 Planos + 8 Bonos &gt;&gt;
          </p>
          <p className="text-xs text-gray-500" data-id="element-119">
            Pago único. Sin cargos mensuales.
          </p>

          <CountdownBanner data-id="element-120" />
        </div>
      </div>
    </section>;
}